var React = require('react');

function AutocompleteChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,6.051,5.484,0l5.484,6.051","transform":"translate(2.119 1.5)","fill":"none","stroke":"#707070","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

AutocompleteChevron.defaultProps = {"width":"15.205","height":"9.67","viewBox":"0 0 15.205 9.67"};

module.exports = AutocompleteChevron;

AutocompleteChevron.default = AutocompleteChevron;
